import type { GatsbyBrowser } from 'gatsby';
import * as React from 'react';
import './src/assets/styles/global.css';
import { Layout } from './src/components/layout';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
  props,
}) => {
  return <Layout {...props}>{element}</Layout>;
};

export const onInitialClientRender = () => {
  if (typeof document === 'object') {
    document.getElementById('___loader')!.style.display = 'none';
  }
};
